import { useFlags } from 'launchdarkly-react-client-sdk';
import useQueryParams from '../navigation-utils/useQueryParams';

export const useFeatureToggle = () => {
  const query = useQueryParams();

  const debugTools = query.has('debugTools');

  // Please remove feature toggles no longer in use when merging an experiment
  // This list should have all currently used feature toggle flags.
  const {
    reportsComingSoonTag,
    orgFactoryReset,
    sweepSupportChat,
    priorValueSlackMessages,
    assignmentGroupRoles,
    lgDemo,
    impactAnalysisAiAgent,
    deployAutomationAsFlow,
    hubspotV25,
    permissionsAgent,
    msTeamsCreateAndAddAction,
    tagsCenter,
    automationsAiForCreation,
    supportAgentInAgenticCenter,
    sfFieldFieldsDialog,
    deleteFunnel,
    processMiningV2,
    canvasSections,
    setAsMcp,
    dreamforceDemo,
    canvasStickyNotes,
    usedByInMetadataElements,
    documentationAgentAdvancedMode,
    agentResearchMode,
    snowflakeConnection,
    data360Auth,
    deployFromFunnelLabel,
    weightedGroups,
    multiOrgQuery,
    slackAssignee,
    artifactsPage,
    metadataMappingUpdate,
    wizFuzzyDemo,
    artifactTemplates,
    funnelMapCanvasPreviews,
    orgMigrationDemo,
    pythonExperimentalService,
    assessments,
    asyncResearch,
    agentInMigrationPopup,
    dataAccess,
    serviceNow,
    mcpConnections,
    mcpConnections2,
    mcpConnectorsV2,
    migrationProjectCanvasButton,
    simulationRouting,
    downloadChatAsMd,
    projectV1,
    sfDocV3,
    agentChatFolders,
    hubspotAsOrg,
    supportAgentRefactor,
    workato,
    agenticScans,
    chatAttachments,
    playbooksV2,
    playbooksExportFunctionality,
  } = useFlags();

  return {
    debugTools,
    reportsComingSoonTag,
    orgFactoryReset,
    sweepSupportChat,
    priorValueSlackMessages,
    assignmentGroupRoles,
    lgDemo,
    impactAnalysisAiAgent,
    deployAutomationAsFlow,
    hubspotV2_5: hubspotV25,
    permissionsAgent,
    msTeamsCreateAndAddAction,
    tagsCenter,
    automationsAiForCreation,
    supportAgentInAgenticCenter,
    sfFieldFieldsDialog,
    deleteFunnel,
    processMiningV2,
    canvasSections,
    setAsMcp,
    dreamforceDemo,
    canvasStickyNotes,
    usedByInMetadataElements,
    documentationAgentAdvancedMode,
    snowflakeConnection,
    data360Auth,
    agentResearchMode,
    deployFromFunnelLabel,
    weightedGroups,
    artifactsPage,
    multiOrgQuery,
    slackAssignee,
    metadataMappingUpdate,
    wizFuzzyDemo,
    artifactTemplates,
    funnelMapCanvasPreviews,
    orgMigrationDemo,
    pythonExperimentalService,
    assessments,
    asyncResearch,
    agentInMigrationPopup,
    dataAccess,
    serviceNow,
    mcpConnectionWorkato: mcpConnections,
    mcpConnectionGeneral: mcpConnections2,
    mcpConnectorsV2,
    migrationProjectCanvasButton,
    simulationRouting,
    downloadChatAsMd,
    projectV1,
    sfDocV3,
    agentChatFolders,
    hubspotAsOrg,
    supportAgentRefactor,
    workato,
    agenticScans,
    chatAttachments,
    playbooksV2,
    playbooksExportFunctionality,
  };
};
